const ecommerce = () =>
    import("@/views/ecommerce/Ecommerce");

export const EcommerceRoute = {
    path: "/ecommerce",
    component: ecommerce,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",       
        breadcrumb: [
            {
                disabled: false,
                href: "#",
                text: "Administración Ecommerce",
            }
        ],
        scope:["aps_broker","aps_executive","aps_promotor"]
    }
};